import { render, staticRenderFns } from "./newCases.vue?vue&type=template&id=8abdbff4&scoped=true&"
import script from "./newCases.vue?vue&type=script&lang=js&"
export * from "./newCases.vue?vue&type=script&lang=js&"
import style0 from "./newCases.vue?vue&type=style&index=0&id=8abdbff4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abdbff4",
  null
  
)

export default component.exports